<template>
  <div class="new content-wrapper">
    <h1>Create Chatterbox Text</h1>
    <Chatterbox :chatterbox="chatterbox"></Chatterbox>

    <button class="button" @click="create">Save</button>
  </div>
</template>

<script>
import firebase from 'firebase'
import Chatterbox from '@/components/chatterbox'
import { mapActions } from 'vuex'

export default {
  components: {
    Chatterbox,
  },
  data() {
    return {
      chatterbox: {
        status: 'Draft',
        type: 'Chatterbox',
        content: '',
        url: '',
        siteId: '',
        languageId: '',
      },
    }
  },
  methods: {
    ...mapActions(['createContent']),
    async create() {
      const doc = await this.createContent({ collection: 'chatterbox', newDocument: this.chatterbox }).catch(err => {
        this.$notify({
          text: 'Failed to create chatterbox text',
          type: 'error',
        })
      })
      this.$notify({
        text: 'Successfully created chatterbox text',
        type: 'success',
      })
      this.$router.push({ name: 'chatterboxId', params: { id: doc.id } })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared-styles/button.scss';
</style>
